(function () {
  function enable() {
    document.querySelectorAll('product-gallery[autoplay-media] video-media').forEach(function (vm) {
      if (vm.dataset.qsAutoplay) return;
      var v = vm.querySelector('video');
      if (!v) return;
      vm.dataset.qsAutoplay = '1';

      v.removeAttribute('loading');
      v.removeAttribute('controls');
      v.setAttribute('preload', 'auto');
      v.setAttribute('playsinline', '');
      v.muted = true;
      v.load();

      function start() {
        if (vm.hasAttribute('playing')) return;
        vm.removeAttribute('show-play-button');
        vm.click();
      }

      v.addEventListener('loadeddata', start, { once: true });
      setTimeout(start, 1200);
    });
  }

  enable();
  document.addEventListener('DOMContentLoaded', enable);
  new MutationObserver(enable).observe(document.documentElement, { childList: true, subtree: true });
})();